import { modifyString, StringModifier } from 'constants/copyHelpers';

export const calculateProgressPercentages = (goalsData) => {
  const progressCounts = goalsData?.reduce((counts, goal) => {
    const { progressLevel } = goal;
    counts[progressLevel] = (counts[progressLevel] || 0) + 1;
    return counts;
  }, {});

  const totalGoals = goalsData?.length;

  const resultArray = Object.entries(progressCounts)?.map(([status, count]) => {
    const percentage = (count / totalGoals) * 100;
    const roundedPercentage = parseFloat(percentage.toFixed(2)); // rounding to 2 decimal places

    return {
      status,
      count,
      percentage: roundedPercentage,
    };
  });

  return resultArray;
};

export const calculateGoalsWithOrWithoutCheckIns = (goalsData) => {
  const counts = goalsData?.reduce(
    (result, goal) => {
      const { progressLevel, lastCheckIn } = goal;

      // Count goals based on progressLevel
      result.progressCounts[progressLevel] = (result.progressCounts[progressLevel] || 0) + 1;

      // Count goals with non-null lastCheckIn
      if (lastCheckIn !== null) {
        result.checkInCount += 1;
      }

      return result;
    },
    { progressCounts: {}, checkInCount: 0 }
  );

  return counts;
};

export const getGoalStatus = (goalsAtRisk, goalsWithNoCheckIn, moduleName) => {
  let message = '';
  let color = '';

  switch (true) {
    case goalsAtRisk === 0 && goalsWithNoCheckIn === 0:
      message = `None of your ${modifyString(
        moduleName,
        StringModifier.PLURAL_SENTENCE_CASE
      )} are at-risk, and you have successfully checked into each one. Excellent work!`;
      color = 'success';
      break;

    case goalsAtRisk > 0 && goalsWithNoCheckIn === 0:
      message = `There are ${goalsAtRisk} ${modifyString(
        moduleName,
        StringModifier.PLURAL_SENTENCE_CASE
      )} at risk, and ${goalsWithNoCheckIn} ${goalsAtRisk} ${modifyString(
        moduleName,
        StringModifier.PLURAL_SENTENCE_CASE
      )} that have not been checked into yet. Consistent check-ins enhance the likelihood of achieving ${goalsAtRisk} ${modifyString(
        moduleName,
        StringModifier.PLURAL_SENTENCE_CASE
      )}.`;
      color = 'warning';
      break;

    case goalsAtRisk > 0 && goalsWithNoCheckIn > 0:
      message = `You currently have ${goalsAtRisk} ${modifyString(
        moduleName,
        StringModifier.PLURAL_SENTENCE_CASE
      )} at risk.`;
      color = 'warning';
      break;

    case goalsAtRisk === 0 && goalsWithNoCheckIn > 0:
      message = `There are ${goalsWithNoCheckIn} ${modifyString(
        moduleName,
        StringModifier.PLURAL_SENTENCE_CASE
      )} that you have not checked into. Regular check-ins enhance the likelihood of ${goalsAtRisk} ${modifyString(
        moduleName,
        StringModifier.PLURAL_SENTENCE_CASE
      )} achievement.`;
      color = 'warning';
      break;

    default:
      message = `None of your ${modifyString(
        moduleName,
        StringModifier.PLURAL_SENTENCE_CASE
      )}  are at-risk, and you have successfully checked into each one. Excellent work!`;
      color = 'success';
  }

  return { message, color };
};
